import options from "../../options";
import {strIs} from "@/Utilites/helper";

export class i18n {
  constructor(langValue) {
    this.value = ["en", "ja"].includes(langValue) ? langValue : options.lang;
    this.lang = require("./" + this.value + ".json");
  }

  t(key, capitalize = false) {
    const items = this.lang.items;
    let s = items[key] || key;
    if (s !== "" && s !== key && capitalize) {
      s = s[0].toUpperCase() + s.slice(1);
    }
    return s;
  }

  has(key) {
    return Object.prototype.hasOwnProperty.call(this.lang.items, key);
  }

  static test(a, b, ignoreKeys = []) {
    const langA = require("./" + a + ".json");
    const langB = require("./" + b + ".json");

    i18n.testKeys(a, b, langA, langB);
    i18n.testEmpty(a, b, langA, langB);
    i18n.testEquality(a, b, langA, langB, ignoreKeys);
  }

  static testKeys(a, b, langA, langB) {
    // first test all keys are present in both
    let errors = [];
    for (const key in langA.items) {
      i18n.testEntryFound(a, b, langA, langB, key, errors);
    }
    for (const key in langB.items) {
      i18n.testEntryFound(b, a, langB, langA, key, errors);
    }

    if (errors.length > 0) i18n.logErrors(a, b, "missing keys", errors);
  }

  static testEquality(a, b, langA, langB, ignoreKeys = []) {
    const errors = [];
    for (const key in langA.items) {
      if (ignoreKeys.includes(key)) continue;
      i18n.testEntryEquality(a, b, langA, langB, key, errors);
    }

    if (errors.length > 0) i18n.logErrors(a, b, "matching keys", errors);
  }

  static testEmpty(a, b, langA, langB, ignoreKeys = []) {
    const errors = [];
    for (const key in langA.items) {
      if (ignoreKeys.includes(key)) continue;
      i18n.testEntryEmpty(a, langA, key, errors);
    }
    for (const key in langB.items) {
      if (ignoreKeys.includes(key)) continue;
      i18n.testEntryEmpty(b, langB, key, errors);
    }

    if (errors.length > 0) i18n.logErrors(a, b, "empty keys", errors);
  }

  static testEntryFound(source, target, sourceLang, targetLang, key, errors) {
    if (!Object.prototype.hasOwnProperty.call(targetLang.items, key))
      errors.push(`${target} - ${key}`);
  }

  static testEntryEquality(
    source,
    target,
    sourceLang,
    targetLang,
    key,
    errors
  ) {
    if (sourceLang.items[key] === targetLang.items[key]) errors.push(`${key}`);
  }

  static testEntryEmpty(target, targetLang, key, errors) {
    if (!strIs(targetLang.items[key])) errors.push(`${target} - ${key}`);
  }

  static logErrors(a, b, message, errors) {
    if (errors.length > 0) {
      console.warn(
        `Tested ${a}<->${b}:  \nFound ${
          errors.length
        } ${message}\n${errors.join("\n")}`
      );
    }
  }
}
